/**
 * Bucket layout for the image-renderer's baked derivatives. The objects are
 * immutable and content-addressed, so the version is bumped to re-bake.
 */
const TILE_KEY_VERSION = "v2";
const BUCKET_MARKER_VERSION = "v2";
const OG_CACHE_VERSION = "v2";
/**
 * Prefix a baked tile is stored and served under, for a given output width.
 * The renderer writes to it and the frontend reads from it.
 */
export function tileObjectPrefix(width) {
    return `tiles/${TILE_KEY_VERSION}/w${width}`;
}
/**
 * Redis key marking that a calendar card has been uploaded to the bucket. The
 * renderer writes it and the server reads it to skip re-invoking the function.
 */
export function bucketMarkerKey(calendarId, size) {
    return `image-renderer:bucket:${BUCKET_MARKER_VERSION}:${calendarId || "none"}:${size || "unknown"}`;
}
/**
 * Redis key holding a rendered calendar card, keyed by the inputs that change
 * the pixels.
 */
export function ogCacheKey(calendarId, size, dpr) {
    return `public-render:calendar-image:${OG_CACHE_VERSION}:${calendarId || "none"}:${size}:dpr=${dpr}`;
}
//# sourceMappingURL=imageDerivatives.js.map